import PropTypes from "prop-types";
import { Component } from "react";
import { v4 as uuidv4 } from "uuid";
import ErrorMessage from "../ErrorMessage";
import LogOutButton from "./LogOutButton";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorReferenceId: uuidv4().slice(0, 8).toUpperCase(), errorPayload: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const payload = {
      client: "See SWA-STARS-IDToken",
      error: error.toString(),
      // Very strange AWS API Gateway issue occurs if `localhost` exists in the payload...
      error_info: JSON.stringify(errorInfo).replaceAll("localhost", ""),
      service: "stars-trade-form-client-module",
      error_code: this.props.code,
      rrn: this.state.errorReferenceId,
      session_data: window.localStorage
    };
    this.setState({errorPayload: payload})
  }

  render() {
    if (this.state.hasError && !!this.state.errorPayload) {
      return (
        <div className="App" data-testid="error-boundary-page">
          <div>
              <ErrorMessage
              errorMessage={this.props.message}
              errorCode={this.props.code}
              errorReferenceId={this.state.errorReferenceId}
              errorPayload={this.state.errorPayload}
            />
            <LogOutButton />
            </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  message: PropTypes.string.isRequired,
};

export default ErrorBoundary;